import { Navigate, Route, Routes } from 'react-router-dom';
import { InputScreen } from './screens/InputScreen';
import { ResultScreen } from './screens/ResultScreen';
import { HistoryScreen } from './screens/HistoryScreen';
import { ErrorBoundary } from './components/ErrorBoundary';
import { useTheme } from './hooks/useTheme';

export default function App() {
  useTheme();
  return (
    <ErrorBoundary>
      <Routes>
        <Route path="/" element={<InputScreen />} />
        <Route path="/history" element={<ErrorBoundary><HistoryScreen /></ErrorBoundary>} />
        <Route
          path="/result/:slug"
          element={
            <ErrorBoundary>
              <ResultScreen />
            </ErrorBoundary>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </ErrorBoundary>
  );
}
